/******************************************************************************************
 *	Select Team Member Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.selectTeamMemberModal', [])
    .factory(
      'SelectTeamMemberModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/select-team-member-modal.html',
          controller: 'SelectTeamMemberModalController',
          classNames: 'select-team-member-modal'
        });
      }
    )
    .controller(
      'SelectTeamMemberModalController',
      /* @ngInject */
      function(
        _,
        $log,
        $scope,
        SelectTeamMemberModal,
        CurtainNotifications,
        Languages,
        TeamMembers,
        SspList,
        Settings
      ) {
        var getActiveTeamMembers = function() {
          $scope.loadingTeamMembers = true;

          //Get active team members
          TeamMembers.get(true) //True flag specifies fetching only active team members
            .then(function(responseData) {
              initTeamMembers(responseData);
              $scope.loadingTeamMembers = false;
              $scope.noData = false;
            })
            .catch(function(response) {
              $scope.loadingTeamMembers = false;
              $scope.noData = true;
              $scope.errorMessage = 'global.dataList.emptyMessages.noResultsFound';

              CurtainNotifications.show(
                CurtainNotifications.ERROR,
                'selectTeamMemberModal.notifications.noTeamMembers'
              );
              $log.error('Failed to fetch team members', response.data);
            });
        };

        //Team Members Data List init and refresh
        var teamDataList;
        var refreshTeamMembers = function(options) {
          $scope.teamMembers = teamDataList.get(options);
          if (!$scope.teamMembers.data.length) {
            $scope.noSearchResults = true;
            $scope.errorMessage = 'global.dataList.emptyMessages.noResultsFound';
          } else {
            $scope.noSearchResults = false;
          }
        };

        var initTeamMembers = function(data) {
          //Deny selection of team members with IDs contained in the $scope.excludedUserIDs list
          _.forEach(data, function(person) {
            if (_.includes($scope.excludedUserIDs, person.userId)) {
              person.notSelectable = true;
            }
          });

          teamDataList = new SspList(data, {
            itemsPerPage: Settings.itemsPerPage.teamMembersModal,
            searchFields: ['first_name', 'last_name', 'email', 'status'],
            fallbackSort: {column: 'first_name,last_name,email'},
            minSearchLength: Languages.minSearchLength()
          });

          refreshTeamMembers({page: 1});
        };

        //Pagination
        $scope.prevPage = function() {
          var page = $scope.teamMembers.pagination.currentPage - 1;
          refreshTeamMembers({page: page});
        };
        $scope.nextPage = function() {
          var page = $scope.teamMembers.pagination.currentPage + 1;
          refreshTeamMembers({page: page});
        };

        //Sorting
        $scope.sort = function(column, serverColumns, isNumeric) {
          refreshTeamMembers({sortBy: column, sortNumeric: isNumeric});
        };

        //Search
        $scope.search = function(query) {
          refreshTeamMembers({query: query});
        };
        $scope.clearSearch = function() {
          teamDataList.clearSearch();
          refreshTeamMembers();
        };

        //Initial call to get Team Members
        getActiveTeamMembers();

        //Selection logic
        $scope.selectedTeamMember = null;
        $scope.setSelectedTeamMember = function(teamMember) {
          if (!teamMember.notSelectable) {
            $scope.selectedTeamMember = teamMember;
          }
        };
        $scope.isSelected = function(teamMember) {
          return $scope.selectedTeamMember === teamMember;
        };

        $scope.submit = function() {
          SelectTeamMemberModal.remove({teamMember: $scope.selectedTeamMember});
        };

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          SelectTeamMemberModal.remove({cancelled: true});
        };
      }
    );
})();
